export default __webpack_public_path__ + "static/blog-404-sim-mobile-34d9a1d4dc2d4ed299320d0fc6f86be3.png";